import React from "react";
import "./Spinner.scss";

const Spinner = ({ alt, secondary }) => (
  <div className={`lds-ellipsis${alt ? " alt" : ""}${secondary ? " secondary" : ""}`}>
    <div />
    <div />
    <div />
    <div />
  </div>
);

export default Spinner;
